export enum CoordinationStatusColorInfraEnum {
    COORDINATION_UNKNOWN = 'medium',
    COORDINATION_CREATED = 'yelloworange',
    COORDINATION_REMOVED = 'medium',
    COORDINATION_PENDING_ACCEPTANCE = 'activated',
    COORDINATION_PENDING_REVIEW = 'orangered',
    COORDINATION_APPROVED = 'success',
    COORDINATION_COORDINATED = 'zomp',
    COORDINATION_ACTIVATED = 'pistachio',
    COORDINATION_DEACTIVATED = 'queenblue',
    COORDINATION_FINISHED = 'dimmed',
    COORDINATION_CANCELLING = 'yelloworange',
    COORDINATION_CANCELLED = 'redsalsa',
    COORDINATION_SUSPENDING = 'maizecrayola',
    COORDINATION_SUSPENDED = 'orangered',
    COORDINATION_REJECTED = 'danger',
    COORDINATION_UNDERTEST = 'medium',
  }